import React, { useEffect, useState, useMemo } from 'react';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import BuyItAgainDynamicStore from '@tcp/core/src/components/features/account/BuyItAgain/container/BuyItAgainDynamicStore';
import { getCache } from '@tcp/core/src/utils/cache.util';
import { getUserLoggedInState } from '@tcp/core/src/components/features/account/User/container/User.selectors';
import { BadgesContext } from '../context/Badges.context';
import { getBuyItAgainProducts } from '../../../account/BuyItAgain/container/BuyItAgain.actions';
import { getBiaApiResponse } from '../../../account/BuyItAgain/container/BuyItAgain.selectors';
import {
  getIsLastPurchasedEnabled,
  getIsPrevPurchasedBadgeEnable,
} from '../../../../../reduxStore/selectors/session.selectors';

const BadgesProvider = ({
  children,
  previouslyPurchasedBadgeData,
  getPreviouslyPurchasedBadgeData,
  productId,
  isLoggedIn,
  isLastPurchasedEnabled,
  isPrevPurchasedBadgeEnable,
  isQv,
}) => {
  const [cachedResult, setCachedRes] = useState(null); // State to hold cached data

  const userPurchaseHistory = useMemo(() => {
    if (!isEmpty(previouslyPurchasedBadgeData)) {
      return previouslyPurchasedBadgeData;
    }
    if (!isEmpty(cachedResult)) {
      return cachedResult;
    }
    return [];
  }, [previouslyPurchasedBadgeData, cachedResult]);

  useEffect(() => {
    async function fetchData() {
      const cachedRes = await getCache('getUserPurchaseHistory');
      if (!cachedRes || !cachedRes?.biaProducts) {
        await BuyItAgainDynamicStore();
        getPreviouslyPurchasedBadgeData({ cacheTTL: 30 });
      } else {
        setCachedRes(cachedRes?.biaProducts);
      }
    }
    if (isLoggedIn) {
      fetchData().then();
    }
  }, [isLoggedIn]);

  const isProductPurchasedPreviously = useMemo(() => {
    return userPurchaseHistory?.some((ppProduct) => {
      return ppProduct?.productId === productId;
    });
  }, [userPurchaseHistory, productId]);

  return (
    <BadgesContext.Provider
      value={{
        previouslyPurchasedBadgeData: userPurchaseHistory,
        getPreviouslyPurchasedBadgeData,
        productId,
        isLoggedIn,
        isLastPurchasedEnabled,
        isProductPurchasedPreviously,
        isPrevPurchasedBadgeEnable,
        isQv,
      }}
    >
      {children}
    </BadgesContext.Provider>
  );
};

const mapStateToProps = (state) => ({
  previouslyPurchasedBadgeData: getBiaApiResponse(state),
  isLoggedIn: getUserLoggedInState(state),
  isLastPurchasedEnabled: getIsLastPurchasedEnabled(state),
  isPrevPurchasedBadgeEnable: getIsPrevPurchasedBadgeEnable(state),
});

const mapDispatchToProps = (dispatch) => ({
  getPreviouslyPurchasedBadgeData: (payload) => dispatch(getBuyItAgainProducts(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BadgesProvider);
